/**
 * Onglet Gestion des tokens
 * @module admin/tabs/TokensTab
 */

import React, { useEffect } from 'react';
import { useTokens } from '../hooks/useTokens';
import AdminResult from '../components/AdminResult';

const formatTimeUntilExpiry = (ms) => {
  if (!ms) return null;
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}min`;
};

const TokensTab = () => {
  const {
    tokenStatus,
    maintenanceLoading,
    maintenanceResult,
    maintenanceError,
    fetchTokenStatus,
    handleRefreshToken,
  } = useTokens();

  useEffect(() => {
    fetchTokenStatus();
  }, [fetchTokenStatus]);

  const renderTokenCard = (service, status) => (
    <div key={service} className="admin-token-card">
      <h3>Token {service === 'twitch' ? 'Twitch' : 'Spotify'}</h3>
      <div className="admin-token-details">
        <p>
          <strong>Tokens présents:</strong> {status?.hasTokens ? 'Oui' : 'Non'}
        </p>
        <p>
          <strong>État:</strong> {status?.isExpired ? 'Expiré' : 'Valide'}
        </p>
        {status?.expiresAt && (
          <p>
            <strong>Expire le:</strong>{' '}
            {new Date(status.expiresAt).toLocaleString('fr-FR')}
          </p>
        )}
        {status?.timeUntilExpiry && (
          <p>
            <strong>Temps restant:</strong>{' '}
            {formatTimeUntilExpiry(status.timeUntilExpiry)}
          </p>
        )}
        {status?.userData && (
          <div className="admin-token-user">
            <strong>Utilisateur:</strong>
            <p>ID: {status.userData.id}</p>
            <p>Login: {status.userData.login}</p>
            <p>Nom: {status.userData.display_name}</p>
          </div>
        )}
        {status?.error && (
          <p className="admin-error">
            <strong>Erreur:</strong> {status.error}
          </p>
        )}
      </div>
      <button
        className="admin-button admin-button-primary"
        onClick={() => handleRefreshToken(service)}
        disabled={maintenanceLoading || !status?.hasTokens}
      >
        {maintenanceLoading
          ? 'Refresh en cours...'
          : `Rafraîchir token ${service === 'twitch' ? 'Twitch' : 'Spotify'}`}
      </button>
    </div>
  );

  return (
    <section className="admin-section">
      <h2>🔐 Gestion des tokens</h2>

      {tokenStatus ? (
        <div className="admin-token-status">
          {renderTokenCard('twitch', tokenStatus.twitch)}
          {renderTokenCard('spotify', tokenStatus.spotify)}
        </div>
      ) : (
        <p className="admin-loading">Chargement du statut des tokens...</p>
      )}

      <button
        className="admin-button admin-button-secondary"
        onClick={fetchTokenStatus}
      >
        Actualiser le statut
      </button>

      {maintenanceResult && (
        <AdminResult isSuccess={true} title="Résultat du refresh">
          <p>
            <strong>Message:</strong> {maintenanceResult.message}
          </p>
        </AdminResult>
      )}

      {maintenanceError && (
        <AdminResult isSuccess={false} title="Erreur du refresh" message={maintenanceError} />
      )}
    </section>
  );
};

export default TokensTab;
